// UpdateAvailableBanner.js
//
// Mounted once in index.js, outside App.js's own branching (which has several independent
// early-return screens — login, loading, suspended, each dashboard) — as a sibling at the true
// root, so it shows no matter which screen is active, login included. Needed because
// service-worker.js calls clientsClaim() but nothing ever told a WAITING worker to skipWaiting();
// by default CRA's service worker only activates a new deploy once every tab is fully closed,
// so without this, a real deploy (new branding, a bug fix, anything) silently sits cached until
// the user happens to close every tab — confirmed live: Filipp saw stale "Shark Pulse" branding
// well after the rebrand had actually deployed and been verified fresh in an uncached browser.
import React, { useEffect, useState } from 'react';
import { RADIUS, COLORS, SHADOW, SAFE_INSET } from './theme';

function UpdateAvailableBanner() {
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const handler = (e) => setRegistration(e.detail);
    window.addEventListener('sw-update-available', handler);
    return () => window.removeEventListener('sw-update-available', handler);
  }, []);

  const handleRefresh = () => {
    if (!registration || !registration.waiting) {
      window.location.reload();
      return;
    }
    // service-worker.js's own message listener calls self.skipWaiting() on this exact message.
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  };

  if (!registration) return null;

  return (
    <div
      style={{
        position: 'fixed', bottom: `calc(20px + ${SAFE_INSET.bottom})`, left: '50%', transform: 'translateX(-50%)', zIndex: 10000,
        backgroundColor: COLORS.text, color: COLORS.white, padding: '12px 18px', borderRadius: RADIUS.md,
        boxShadow: SHADOW.raised, display: 'flex', alignItems: 'center', gap: '14px',
        fontSize: '13px', maxWidth: 'calc(100vw - 40px)', flexWrap: 'wrap', justifyContent: 'center'
      }}
    >
      <span>A new version of TaskWRX is available.</span>
      <button
        type="button"
        onClick={handleRefresh}
        style={{ padding: '6px 16px', backgroundColor: COLORS.white, color: COLORS.text, border: 'none', borderRadius: RADIUS.md, fontWeight: '700', fontSize: '12px', cursor: 'pointer', whiteSpace: 'nowrap' }}
      >
        Refresh
      </button>
    </div>
  );
}

export default UpdateAvailableBanner;
